jQuery(document).ready(function($) {



// Hamburgerbutton //
         var videop = 0;
      var hamburger = document.querySelector(".hamburger");
      // On click
      hamburger.addEventListener("click", function() {
    // Toggle class "is-active"
      hamburger.classList.toggle("is-active");
    // Do something else, like open/close menu
      $('header .menu').css('background-color', localStorage.farbe);
      $('#toolbar').css('background-color',localStorage.farbe);
      $('header .menu').toggleClass('hammenu');
      $('header .newslettermenu').toggleClass('hammenu');
      $('header .socialmedialinks').toggleClass('hammenu');
      $("body").removeClass("js-my-cart-open");

  });
//     Youtubevideo Vorbereitung für API Controll //
       if($('body').hasClass('page-video')) {
       var videoids=['v0']; //v0 ist das homevideo, ab v1 dann workvideos //
       var vidv0 = $('.page-video').find('iframe');
       var orgv0 = vidv0.attr('src');
       var shortv0 = orgv0.split('?')[0];
       vidv0.attr('src', shortv0 + '?enablejsapi=1&rel=0&showinfo=0&controls=1');
       vidv0.attr('id','v0');
       };
  if(sessionStorage.offen == 1) {
    hamburger.classList.remove("is-active");
    $('header .menu').removeClass('hammenu');
    $('header .newslettermenu').removeClass('hammenu');
    $('header .socialmedialinks').removeClass('hammenu');
  }
  else if ($('body').hasClass('page-seifenmacher')) {
    sessionStorage.offen = 1;
    hamburger.classList.add("is-active");
    $('header .menu').addClass('hammenu');
    $('header .newslettermenu').addClass('hammenu');
    $('header .socialmedialinks').addClass('hammenu');
  }  
      
    $(".forgot-password a").click(function() {
      $(".customer-login, .guest-login, .recover-password").toggle();
  });
  $(".recover-cancel a").click(function() {
    $(".customer-login, .guest-login, .recover-password").toggle();
  });


      $(".produktdisplay").mouseenter(function(event){

        event.preventDefault();
        //letzte Farbe lokal speichern mit sessionStorage //
        localStorage.farbe = $(this).find('code.farbe').text();

        farbe = localStorage.farbe;

        $("body").css("background-color", farbe);
        $("header").css("background-color", farbe);
        $(".warenkorbgross").css("color", farbe);
        $('.ajax-cart-row').css('border-bottom-color', farbe);
        //new
        $('.ajax-cart-row').css('color', farbe);
        $('.ajax-cart-row a').css('color', farbe);
        $('.ajax-cart-row input[type="number"].quantity-input ').css('color', farbe);


        // $('.ajax-shopping-cart-table input[type=text]').css('color',farbe);
        $('.ajax-shopping-cart-table input[type=submit]').css('color',farbe);
        // $('.remove-from-cart a').css('color',farbe);
        $('.ajax-shopping-cart-total').css('border-bottom-color', farbe);
        $('.menu').css('background-color', farbe);
        $('.warenkorbzu').css('color',farbe);
        $('.warenkorbzu').css('border-bottom-color',farbe);

        $(this).find('.produktinfos h1').addClass('unterstrichen');



      });
      $(".produktdisplay").mouseleave(function(event){
        event.preventDefault();
      $(this).find('.produktinfos h1').removeClass('unterstrichen');
      });

      // Überprüfen, ob das Element mit der Klasse "produktdisplaydetail" vorhanden ist
      // Detailseite: eigene Produktfarbe aus code.farbe verwenden,
      // nur falls keine vorhanden ist, die zuletzt gespeicherte Farbe
      if ($('.produktdisplaydetail').length > 0) {
          var detailFarbe = $.trim($('.produktdisplaydetail code.farbe').first().text());
          if (detailFarbe) {
            localStorage.farbe = detailFarbe;
          }
          var seitenFarbe = localStorage.farbe;
          if (seitenFarbe) {
            $('body').css('background-color', seitenFarbe);
            $('header').css('background-color', seitenFarbe);
            $('.menu').css('background-color', seitenFarbe);
            $('#toolbar').css('background-color', seitenFarbe);
            $('.warenkorbgross').css('color', seitenFarbe);
            $('.warenkorbzu').css('color', seitenFarbe);
            $('.warenkorbzu').css('border-bottom-color', seitenFarbe);
          }
        }
      


// Funktion, um den Wert des Mengen-Inputs zu erhöhen
function increaseQuantity(event) {
  var quantityInput = event.target.previousElementSibling;
  var currentValue = parseInt(quantityInput.value);
  quantityInput.value = currentValue + 1;
}

// Funktion, um den Wert des Mengen-Inputs zu verringern
function decreaseQuantity(event) {
  var quantityInput = event.target.nextElementSibling;
  var currentValue = parseInt(quantityInput.value);
  if (currentValue > 1) {
    quantityInput.value = currentValue - 1;
  }
}

// Schaltflächen-Elemente abrufen
var quantityUpButtons = document.querySelectorAll('.quantity-up');
var quantityDownButtons = document.querySelectorAll('.quantity-down');

// Klick-Ereignis-Handler hinzufügen
quantityUpButtons.forEach(function(button) {
  button.addEventListener('click', increaseQuantity);
});
quantityDownButtons.forEach(function(button) {
  button.addEventListener('click', decreaseQuantity);
});







class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
    };
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    this.elements.input.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }
}

customElements.define('localization-form', LocalizationForm);



//*****************//
// Slick Slideshow //
//*****************//

//closebutton textteile
      $("img.closesvg").click(function(event){
        event.preventDefault();
        $(".seifenmacher-textfeld").addClass("geschlossen");
        $('.diacontrol').addClass('sichtbar');
        $("header div.drehenquer").addClass("versteckt");
        $(this).addClass('versteckt');
        $('.diacounter').text(($(".slick-slider").slick("getSlick").currentSlide+1) + " | "+ $(".slick-slider").slick("getSlick").slideCount);

      });
      //closebutton popup
      $(".sm-popup-fenster img.closepop").click(function(event){
        event.preventDefault();
        $(".sm-popup-fenster").addClass("geschlossen");
      });
      $(".sm-popup-fenster2 img.closepop").click(function(event){
        event.preventDefault();
        $(".sm-popup-fenster2").addClass("geschlossen");
      });

      //diashow verlassen
      $(".diaverlassen").click(function(event){
        event.preventDefault();
        $(".seifenmacher-textfeld").removeClass("geschlossen");
        $('.diacontrol').removeClass('sichtbar');
        $(this).addClass('versteckt');
        $("header div.drehenquer").removeClass("versteckt");
        $("img.closesvg").removeClass('versteckt');
      });
      //warenkorbmenu close/open
      $(".menuwarenkorb").click(function(event){
        event.preventDefault();
        $(".warenkorbgross").toggleClass("offen");
      });
      $(".warenkorbzu").click(function(event){
        event.preventDefault();
            $("body").removeClass("js-my-cart-open");
      });
$('.cycleshow').slick({
  prevArrow: false,
  nextArrow: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  variableWidth: true,
  centerMode: false,
  autoplay: true,
  autoplaySpeed: 7000
});
$('.teamshow').slick({
  prevArrow: false,
  nextArrow: false,
  slidesToShow: 2,
  slidesToScroll: 1,
  variableWidth: true,
  autoplay: true,
  autoplaySpeed: 4000,
  responsive: [
  {
    breakpoint: 769,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }
]
});
$('.slick-list.draggable').css('padding','0px 0px');
//Slickcontrolls//


$("a.diaprev").click(function(event){
  event.preventDefault;
  $('.cycleshow').slick('slickPrev');
  $('.teamshow').slick('slickPrev');
});
$("a.dianext").click(function(event){
  event.preventDefault;
  $('.cycleshow').slick('slickNext');
  $('.teamshow').slick('slickNext');
});
$('.cycleshow').on('beforeChange', function(event, slick, currentSlide, nextSlide){
  $('.diacounter').text(($(".cycleshow").slick("getSlick").currentSlide+1) + " | "+ $(".cycleshow").slick("getSlick").slideCount);
});
$('.teamshow').on('beforeChange', function(event, slick, currentSlide, nextSlide){
  $('.diacounter').text(($(".teamshow").slick("getSlick").currentSlide+1) + " | "+ $(".teamshow").slick("getSlick").slideCount);
});
//Pfeiletasten//
$("body").keydown(function(e) {
  if(e.keyCode == 37) { // left
    $('.cycleshow').slick('slickPrev');
    $('.teamshow').slick('slickPrev');
  }
  else if(e.keyCode == 39) { // right
    $('.cycleshow').slick('slickNext');
    $('.teamshow').slick('slickNext');
  }
});
// Farbwechsel beim Scrollen: nur Produkte im mittleren Streifen des Bildschirms zaehlen.
// Streifen relativ zur Bildschirmhoehe (frueher fix 280px oben/unten -> im Querformat
// auf dem Handy blieb nichts uebrig und die Farbe wechselte nie).
function farbStreifen() {
  var rand = Math.round(window.innerHeight * 0.35);
  inView.offset({ top: rand, right: 0, bottom: rand, left: 0 });
}
farbStreifen();
$(window).on('resize orientationchange', farbStreifen);

// Bestaetigung auf dem Button, wenn ein Produkt in den Warenkorb gelegt wurde
// (der Warenkorb oeffnet sich nicht mehr automatisch, siehe addToCartCssClass in theme.liquid)
var bestaetigungAktiv = false;
function warenkorbBestaetigung() {
  if (bestaetigungAktiv || !window.liquidAjaxCart || !liquidAjaxCart.subscribeToCartAjaxRequests) return;
  bestaetigungAktiv = true;
  var aktiverButton = null;
  $(document).on('click', '.add-to-cart-btn, .add-to-cart-btn-promo', function () { aktiverButton = this; });
  liquidAjaxCart.subscribeToCartAjaxRequests(function (requestState, subscribeToResult) {
    if (requestState.requestType !== 'add') return;
    var btn = aktiverButton;
    subscribeToResult(function (requestState) {
      if (!requestState.responseData || !requestState.responseData.ok) return;
      // Warenkorb im Header kurz "huepfen" lassen (CSS-Animation .wk-bump)
      var wk = document.querySelector('header .warenkorbklein');
      if (wk) {
        wk.classList.remove('wk-bump');
        void wk.offsetWidth; // Animation neu starten, auch bei schnellem Doppelklick
        wk.classList.add('wk-bump');
        setTimeout(function () { wk.classList.remove('wk-bump'); }, 700);
      }
      if (!btn) return;
      var original = btn.innerHTML;
      var englisch = (document.documentElement.lang || 'de').indexOf('en') === 0;
      btn.innerHTML = englisch ? 'Added \u2713' : 'Hinzugef\u00fcgt \u2713';
      btn.classList.add('hinzugefuegt');
      setTimeout(function () {
        btn.innerHTML = original;
        btn.classList.remove('hinzugefuegt');
      }, 2000);
    });
  });
}
document.addEventListener('liquidAjaxCartInit', warenkorbBestaetigung);
warenkorbBestaetigung();

inView('.produktdisplay').on('enter', function(el){
  // Mehrere Produkte pro Reihe: nur das vorderste der Reihe bestimmt die Farbe
  var vorher = el.previousElementSibling;
  if (vorher && Math.abs(vorher.getBoundingClientRect().top - el.getBoundingClientRect().top) < 5) {
    return;
  }
  var farbe = $(el).attr('data-color');
        $("body").css("background-color", farbe);
        $("header").css("background-color", farbe);
        $(".warenkorbgross").css("color", farbe);
        $('.ajax-cart-row').css('border-bottom-color', farbe);
        // $('.ajax-shopping-cart-table input[type=text]').css('color',farbe);
        $('.ajax-shopping-cart-table input[type=submit]').css('color',farbe);
        // $('.remove-from-cart a').css('color',farbe);
        $('.ajax-shopping-cart-total').css('border-bottom-color', farbe);
        $('.menu').css('background-color', farbe);
        $('.warenkorbzu').css('color',farbe);
        $('.warenkorbzu').css('border-bottom-color',farbe);
});

});
